const AudioFeedModel = ($data, teams, gamePk) => {
    const data = $data;
    const homeOrAway = data?.team;
    const team = teams?.[homeOrAway];
    if (!team) {
        return null;
    };
    const language = data?.language && data.language !== 'en' && data.language;
    const feedData = {
        gamePk,
        type: 'audio',
        id: data.id,
        callSign: data?.callSign,
        mediaState: data?.mediaState,
        displayCode: team?.abbreviation,
        mediaId: data?.mediaId,
        displayLanguage: language
    };
    return feedData;
};

export default AudioFeedModel;
